import { ReactComponent as IconTnc } from '@/assets/svgs/icon-info.svg';
import Button from "@/components/Button/index";
import { Csat } from '@/components/CSAT';
// [DS-MIGRATION] legacy Navigation - replaced by AppSidebar. Remove in follow-up PR.
// import Navigation from '@/components/Navigation';
import AppSidebar from '@/dsComponents/AppSidebar';
import NotificationPopup from '@/components/NotificationPopup/index';
import Profile from '@/components/Profile';
import PortalNav from '@/components/PortalNav';
import Toast from '@/components/Toast';
import TopBanner from '@/components/TopBanner';
import CardConfigure from "@/componentsDS/Modal/CardConfigure";
import Modal from "@/componentsDS/Modal/Modal";
import { useBuildex } from "@/hooks/use-buildex/index";
import useModal from '@/hooks/use-modal';
import useNotification from '@/hooks/use-notification-popup/useNotifications.jsx';
import useTnc from '@/hooks/use-tnc';
import useToast from '@/hooks/use-toast';
import { useTradex } from "@/hooks/use-tradex/index";
import useWhatsNew from '@/hooks/use-whatsnew';
import Layout, { LayoutType } from '@/layoutDS/layoutDS';
import { useNavigate } from '@/lib/router-dom';
import { useLocation } from '@/lib/router-dom/index';
import NewFeatures from "@/pages/newfeatures/new-features.jsx";
import { logout } from '@/redux/actions/auth.js';
import API_PROFILE from '@/services/api/profile.js';
import { getDexConfig } from '@/utils/get-dex-config';
import { getEnvAndDex } from '@/utils/get-env-and-dex';
import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHealthdex } from '@/hooks/use-healthdex/index';
import { Box, Checkbox } from '@dextech-ai/dex-design-system';

const SHELL_HOSTED = process.env.REACT_APP_SHELL_HOSTED === 'true';

const RenderProfile = ({user, options, handleSelected, isBuildex, isHealthdex}) => {
	const getProfileLabel = (user, isBuildex, isHealthdex) => {
		if (user?.isAdmin) {
			return isBuildex || isHealthdex ? "Admin" : "SGTraDex";
		}
		return user?.orgName;
	};

	const profileLabel = getProfileLabel(user, isBuildex, isHealthdex);

	return <Profile image={user?.image} label={profileLabel} options={options} handleSelected={handleSelected} />
}

const DefaultLayout = ({ children }) => {

	const { goTo, navigate } = useNavigate()
	const { currentPath } = useLocation()

	const dispatch = useDispatch()
	const user = useSelector(state => state.auth.user)
	const environments = useSelector(state => state.auth.environments)
	const profile = sessionStorage.getItem('profile')
	const userLoggedInProfile = JSON.parse(profile || null);
	const isLoggedIn = useSelector(state => state.auth.loggedIn)

	const [showWhatsNew, setShowWhatsNew] = useState(false);

	const [alertMessage, setAlertMessage] = useState({
		status: null, message: null
	});

	const toastType = {
		success: "success",
		error: "error"
	}

	/*=================================================
		API
	/================================================*/

	const { toastList, addToastMessage } = useToast()
	const { unseenCount, isActive: showNotificationsPopup, notificationArr, loading, onlyUnRead, handleRedirect, markReadNotificationItem, showUnreadNotifications, initNotifications, getAllNotifications, getAllUnseenNotificationsCount, markNotificationsAsSeen, handlePopup, markReadAllNotifications, pivotNotification } = useNotification()
	const [countArr, setCountArr] = useState([])

	const generateCountArr = (num) => {
		const arr = Array(num)
		setCountArr(arr)
	}
	const handleIconClick = () => {
		handlePopup(showNotificationsPopup)
		if (!showNotificationsPopup) {
			setCountArr([])
			markNotificationsAsSeen(unseenCount)
		}
	}


	/*=================================================
		Notifications Handler
	/================================================*/

	useEffect(async () => {
		const count = await getAllUnseenNotificationsCount()
		generateCountArr(count)
	}, [currentPath])

	/*=================================================
		Filter Popup
	/================================================*/

	const [filterVisible, setFilterVisible] = useState()
	const buttonRef = useRef(null)
	const referenceRef = useRef(null)

	useEffect(() => {
		document.addEventListener('mousedown', handleDocumentClick)
		return () => {
			document.removeEventListener('mousedown', handleDocumentClick)
		}
	}, [])

	function handleDocumentClick(event) {

		if (!referenceRef.current) {
			return
		}

		if (referenceRef.current.contains(event.target)) {
			return
		}
		setFilterVisible(false)
	}

	const [banners, setBanners] = useState(() => {
		let arr = []

		return arr;
	})

	function removeBanner(index) {
		return () => {
			sessionStorage.removeItem('banner')
			setBanners(_banners => _banners.filter((_, idx) => idx !== index))
		}
	}


	/*=================================================
		Alert Message
	/================================================*/

	const { visible: visibleNotification, show: showNotification, hide: hideNotification } = useModal()
	const [openAlert, setOpenAlert] = useState(false)

	const messageText = (status) => {
		switch (status) {
			case 'approve':
				return 'Seleted notifications has been marked as read.';
			default:
				return 'Something went wrong handling your Request';
		}
	}

	/*=================================================
		Profile Dropdown
	/================================================*/
	const [, setIsActive] = useState(false)

	const options = [
		"Account Settings",
		"Logout"
	]

	const handleSelected = (option) => {
		if (option === 'Logout') {
			dispatch(logout(navigate))
		}
		if (option === 'Account Settings') goTo("/setting")
	}

	/*=================================================
		Terms & Conditions
	/================================================*/

	const userTnc = userLoggedInProfile.tncStatus;

	const { tnc, fetch: fetchTnc, accept } = useTnc()

	const { visible: visibleTnc, hide: hideTnc } = useModal(!userTnc)
	const { visible: visibleTncDecline, show: showTncDecline, hide: hideTncDecline } = useModal()

	const [tncStatus, setTncStatus] = useState(userTnc)
	const [tncChecked, setTncChecked] = useState(false)
	const [loadingAccept, setLoadingAccept] = useState(false)

	useEffect(() => {
		async function funcFetchTnc() {
			await fetchTnc();
		}

		if(!userTnc) {
			funcFetchTnc()
		}
	}, [])

	function handledCheckedTnc() {
		setTncChecked(!tncChecked)
	}

	async function acceptTnC() {

		setLoadingAccept(true)

		const payload = {
			"accept": true,
			"userId": user?.id
		};

		const [error, result] = await accept(payload)

		if (error) {
			hideTnc()
			return addToastMessage(error?.message, toastType.error)
		}

		setLoadingAccept(false);
		hideTnc();
		setTncStatus(true);
		const [errorProfile, responseProfile] = await API_PROFILE.index()
		sessionStorage.setItem('profile', JSON.stringify(responseProfile))
	}

	/*=================================================
		Features
	/================================================*/
	const { fetchLastesId, setVisible, visible: whatsNewVisible } = useWhatsNew()

	useEffect(async () => {

		if (tncStatus === false) {
			setShowWhatsNew(false);
			return;
		}

		const [error, newFeatures] = await fetchLastesId();

		if (error) {
			setVisible(false);
			return
		}

	}, []);

	const handleWhatsNew = () => {
		setShowWhatsNew(true);
	};


	/*=================================================
		MultiDex
	/================================================*/
	const { dex } = getEnvAndDex();
	const { dexName } = getDexConfig(dex);
	const isBuildex = useBuildex();
	const isHealthdex = useHealthdex();
	const isTradex = useTradex();

	const RenderTnCHeaderText = () => {
		if (isHealthdex) {
			return `Please accept the Terms and Conditions to access ${dexName} information.`
		}
		return 'Please accept the Terms and Conditions to access DEX information.'
	}

	const RenderTnCAcceptText = () => {
		if (isHealthdex) {
			return `I accept the terms and conditions of accessing ${dexName}'s information`
		}
		return `I accept the terms and conditions of accessing DEX's information`
	}

	return (
		<Layout type={LayoutType.Default}>
			<Layout.SideNav>
				{/* [DS-MIGRATION] legacy Navigation - replaced by AppSidebar. Remove in follow-up PR. */}
				{/* {SHELL_HOSTED ? <PortalNav /> : <Navigation />} */}
				{SHELL_HOSTED ? <PortalNav /> : <AppSidebar />}
			</Layout.SideNav>
			<Layout.Header>
				<div className="layout-default__right__top">
					<div className="top-header">
						<Box display="flex" align="center" justify="start" w="50%">
							<div id="bread"></div>
						</Box>

						<Box display="flex" align="center" justify="end" w="50%">
							{
								whatsNewVisible &&
								<Box zIndex={5} ml={5} display="flex">
									<div className="notification-icon notification-icon--flex ">
										<p
											onClick={handleWhatsNew}
											id="whats-new-id"
											className="notifiction_whats_new"
										>
											What's new
										</p>
									</div>
								</Box>
							}

							{!isTradex && (
								<Box zIndex={5} ml={5} display="flex">
									<div className="notification-icon notification-icon--flex notification-icon--bell">
										<div>
											<NotificationPopup
												handleIconClick={handleIconClick}
												isActive={showNotificationsPopup}
												pivotNotification={pivotNotification}
												unseenNotifications={countArr}
												notificationArr={notificationArr}
												onlyUnRead={onlyUnRead}
												getAllNotifications={getAllNotifications}
												markReadNotificationItem={markReadNotificationItem}
												markReadAllNotifications={markReadAllNotifications}
												showUnreadNotifications={showUnreadNotifications}
												initNotifications={initNotifications}
												handleRedirect={handleRedirect}
												setIsActive={setIsActive}
												loading={loading}
												handlePopup={handlePopup}
											/>
										</div>
									</div>
								</Box>
							)}

							<div className="top-header__right__profile">
								<RenderProfile
									user={user}
									options={options}
									handleSelected={handleSelected}
									isBuildex={isBuildex}
									isHealthdex={isHealthdex}
								/>
							</div>
						</Box>
					</div>
				</div>
				<div>
					<TopBanner banners={banners} removeBanner={removeBanner} />
				</div>
			</Layout.Header>

			<Layout.Main>
				{tncStatus === true && children}
				{tncStatus === false && (
					<>
						<Modal visible={visibleTnc} variant='large' close={showTncDecline} >
							<CardConfigure>
								<CardConfigure.Header>
									<CardConfigure.Header.Title>
										<div className="card-configure__header__left">
											<div className="card-configure__title">
												<div className="card-configure__title__left">
													<div className='tnc-modal__icon'><IconTnc /></div>
												</div>
												<div className="card-configure__title__right">
													<div className="card-configure__title__right__top">
														Terms and Conditions
													</div>
												</div>
											</div>
										</div>
									</CardConfigure.Header.Title>
								</CardConfigure.Header>
								<CardConfigure.Body>
									<CardConfigure.Body.Col>

										<div className="card-configure__sub-header">
											<div className="tnc-modal__agree-action">
												<div className="tnc-modal__agree-header">{RenderTnCHeaderText()}</div>
											</div>
										</div>


										<div className="tnc-modal__tcn">
											<div className="tnc-modal__tnc-content" dangerouslySetInnerHTML={{ __html: tnc }}>
											</div>
											<div className="tnc-modal__agree-content">
												<Checkbox checked={tncChecked} onCheckedChange={handledCheckedTnc}>
													{RenderTnCAcceptText()}
												</Checkbox>
											</div>
										</div>
									</CardConfigure.Body.Col>
								</CardConfigure.Body>
								<CardConfigure.Footer>
									<CardConfigure.Footer.Right>
										<Button full maxWidth="100" submit={() => acceptTnC()} disabled={!tncChecked || loadingAccept} text="Continue" loading={loadingAccept} />
									</CardConfigure.Footer.Right>
								</CardConfigure.Footer>
							</CardConfigure>
						</Modal>
						<Modal visible={visibleTncDecline} variant='medium' close={hideTncDecline}>
							<CardConfigure>
								<CardConfigure.Header>
									<CardConfigure.Header.Title>
										<div className="card-configure__header__left">
											<div className="card-configure__title">
												<div className="card-configure__title__right">
													<div className="card-configure__title__right__top">
														Decline Terms and Conditions
													</div>
												</div>
											</div>
										</div>
									</CardConfigure.Header.Title>
								</CardConfigure.Header>
								<CardConfigure.Body>
									<CardConfigure.Body.Col>
										<div className='tcn-modal__decline-text'>
											You need to accept the Terms & Conditions to use this application. You will be automatically logged out if you do not wish to proceed. <br /><br /> You can still login to accept the Terms & Conditions in the future.
										</div>
									</CardConfigure.Body.Col>
								</CardConfigure.Body>
								<CardConfigure.Footer>
									<CardConfigure.Footer.Right>
										<Button full text="Log Out" submit={() => {
											dispatch(logout(navigate))
										}} />
									</CardConfigure.Footer.Right>
								</CardConfigure.Footer>
							</CardConfigure>
						</Modal>
					</>
				)}
				{
					whatsNewVisible && <NewFeatures
						showWhatsNew={showWhatsNew}
						setShowWhatsNew={setShowWhatsNew}
					/>
				}

				<Toast toastList={toastList} />
				{
					isLoggedIn && <Csat userId={userLoggedInProfile?.id} email={userLoggedInProfile?.email} />
				}
			</Layout.Main>
		</Layout>
	)
}

const LoginLayout = ({ children }) => {
	return (
		<>
			{children}
			<Csat />
		</>
	)
}

const Container = ({ layout, children }) => {

	switch (layout) {

		case LayoutType.Default:

			return <DefaultLayout>{children}</DefaultLayout>;

		case LayoutType.Login:

			return <LoginLayout>{children}</LoginLayout>;

		default:

			return <DefaultLayout>{children}</DefaultLayout>;

	}

};

DefaultLayout.propTypes = {

	children: PropTypes.node.isRequired,

};

LoginLayout.propTypes = {

	children: PropTypes.node.isRequired,

};

Container.propTypes = {

	layout: PropTypes.oneOf([LayoutType.Default, LayoutType.Login]).isRequired,

	children: PropTypes.node.isRequired,

};

export { DefaultLayout, LoginLayout, RenderProfile };
export default Container;


RenderProfile.propTypes = {
	user: PropTypes.shape({
		isAdmin: PropTypes.bool,
		orgName: PropTypes.string,
		image: PropTypes.string,
	}).isRequired,
	options: PropTypes.arrayOf(PropTypes.string).isRequired,
	handleSelected: PropTypes.func.isRequired,
	isBuildex: PropTypes.bool.isRequired,
	isHealthdex: PropTypes.bool.isRequired,
};
